import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { hideAlertInfo } from "./store/alertInfo.actions";

const AlertInfoComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const alertInfo = useSelector((state) => state.alertInfo);

  const closeAlert = useCallback(() => {
    dispatch(hideAlertInfo());
  }, [dispatch]);

  useEffect(() => {
    if (alertInfo?.type) {
      const timer = setTimeout(() => {
        closeAlert();
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [alertInfo, closeAlert]);

  return (
    <Stack sx={{ width: "100%", marginBottom: "10px" }} spacing={2}>
      {alertInfo?.type && (
        <Alert
          severity={alertInfo?.type}
          onClose={() => {
            closeAlert();
          }}
          sx={{
            position: "fixed",
            top: "250px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1000,
            boxShadow: "0px 3px 5px rgba(0,0,0,0.2)",
          }}
        >
          {t(`${alertInfo?.message}`)}
        </Alert>
      )}
    </Stack>
  );
};

export default AlertInfoComponent;
